import React, { useState } from "react";
import { FaXmark } from "react-icons/fa6";
import { IoMdArrowDropdown } from "react-icons/io";
import { Dropdown } from "flowbite-react";
import { FiFilter } from "react-icons/fi";
import { VscGoToFile } from "react-icons/vsc";
import { TbWorld } from "react-icons/tb";
import { VscTypeHierarchySub } from "react-icons/vsc";
import FilterActionModal from "./FilterActionModal";
import GotoSheetActionModal from "./GotoSheetActionModal";
import GoToUrlActionModal from "./GoToUrlActionModal";
import { useSelector, useDispatch } from "react-redux";
import {
  getL2SheetProperty,
  deleteAction,
  selectTodoDescriptionsProxy,
  getWorkbookProperty,
  updateLevel2Properties,
} from "../../../WorkbookSlice";
import { v4 as uuidv4 } from "uuid";

const actions = [
  { label: "Filter", value: "Filters" },
  { label: "Go To Sheet", value: "GoToSheet" },
  { label: "Go To Url", value: "GoToURL" },
  { label: "Hierarchy", value: "hierarchy" },
];

export default function ActionModal({ closeModal, selectedSheetId, VizType }) {
  console.log(VizType);

  const Sheetid = selectedSheetId;
  const sheetsArray = useSelector((state) => {
    return selectTodoDescriptionsProxy(state);
  });
  const getOnClickProperties = useSelector((state) => {
    return getL2SheetProperty(state, Sheetid, "actions", "onClick");
  });
  console.log(sheetsArray);
  const getOnDoubleClickProperties = useSelector((state) =>
    getL2SheetProperty(state, Sheetid, "actions", "onDoubleClick")
  );
  console.log(getOnDoubleClickProperties);
  const hierarchy =
    useSelector((state) => getWorkbookProperty(state, "hierarchy")) || {};
  const dispatch = useDispatch();
  const [selectedRow, setSelectedRow] = useState(null);
  console.log(selectedRow);

  const [selectedAction, setSelectedAction] = useState(null);
  console.log(selectedAction);

  const [showSecondModal, setShowSecondModal] = useState(null);
  console.log(showSecondModal);

  let goForward = "onDoubleClick";
  let goBackward = "onClick";

  const handleRowSelection = ({
    uuid,
    parentKey,
    reduxKey,
    Sheetid,
    action,
  }) => {
    console.log(uuid, parentKey, reduxKey, Sheetid, action);

    if (selectedRow !== null && selectedRow.uuid === uuid) {
      setSelectedRow(null);
    } else {
      setSelectedRow({ uuid, parentKey, reduxKey, Sheetid, action });
    }
  };

  const handleEdit = (action) => {
    console.log(action);
    setShowSecondModal(action); // Show the second modal
    // if (action !== null) {
    // }
  };
  const handleRemove = (selectedRow) => {
    const { parentKey, reduxKey, uuid } = selectedRow;
    console.log(parentKey, reduxKey, uuid);
    dispatch(
      deleteAction({
        Sheetid,
        parentKey,
        reduxKey,
        uuid,
      })
    );
  };
  console.log(hierarchy?.[0]?.hierarchyColumn?.rename || null);

  const handleDispatchingHeirarchyObject = () => {
    const currenSheetObject = sheetsArray.find(
      (sheet) => sheet.ID === selectedSheetId
    );
    console.log(currenSheetObject);

    const actionObject = {
      uuid: uuidv4(),
      action: "Hierarchy",
      name: hierarchy?.[0]?.hierarchyColumn?.rename || null,
      sourceSheet: {
        Sheetid: currenSheetObject.ID,
        SheetName: currenSheetObject.SheetName,
      },
      isAllSheets: false,
      targetSheets: [],
      filterType: null,
      goBackward,
      goForward,
    };
    console.log(actionObject);

    dispatch(
      updateLevel2Properties({
        reduxKey: "onClick",
        Sheetid: selectedSheetId,
        parentKey: "actions",
        value: actionObject,
        itemInArray: false,
        index: null,
      })
    );
  };

  const handleOk = () => {
    if (selectedAction === null) {
      console.log("You have selected no action");
      closeModal();
    } else if (selectedAction !== "hierarchy") {
      setShowSecondModal(selectedAction); // Show the second modal
    } else {
      handleDispatchingHeirarchyObject();
      closeModal();
    }
  };

  const CloseSecondModal = () => {
    setShowSecondModal(null);
  };

  const handleSecondModalClose = () => {
    setShowSecondModal(null);
    closeModal(); // Optionally close the original modal if needed
  };
  function sourceSheetObjectNTargetSheetArray(sheetsArray, Sheetid) {
    let sourceSheetObject;
    let targetSheetArray;
    const findSourceSheetObject = sheetsArray.find(
      (item) => item.ID === Sheetid
    );
    sourceSheetObject = findSourceSheetObject
      ? {
          Sheetid: findSourceSheetObject.ID,
          SheetName: findSourceSheetObject.SheetName,
        }
      : {};
    targetSheetArray = sheetsArray
      .filter((item) => item.ID !== Sheetid)
      .map((item) => ({ Sheetid: item.ID, SheetName: item.SheetName }));
    return { sourceSheetObject, targetSheetArray };
  }
  const { sourceSheetObject, targetSheetArray } =
    sourceSheetObjectNTargetSheetArray(sheetsArray, Sheetid);
  console.log(getOnClickProperties);
  console.log(getOnDoubleClickProperties);
  const tabledata = [];
  function objectToPushInTableData(
    getOnClickProperties,
    getOnDoubleClickProperties
  ) {
    let onClickObject, onDoubleClickObject;

    if (getOnClickProperties?.name) {
      onClickObject = {
        uuid: getOnClickProperties.uuid,
        parentKey: "actions",
        reduxKey: "onClick",
        Sheetid: getOnClickProperties.sourceSheet?.Sheetid,
        action: getOnClickProperties.action,
        name: getOnClickProperties.name,
      };
      tabledata.push(onClickObject);
    }

    if (getOnDoubleClickProperties?.name) {
      onDoubleClickObject = {
        uuid: getOnDoubleClickProperties.uuid,
        parentKey: "actions",
        reduxKey: "onDoubleClick",
        Sheetid: getOnDoubleClickProperties.sourceSheet?.Sheetid,
        action: getOnDoubleClickProperties.action,
        name: getOnDoubleClickProperties.name,
      };
      tabledata.push(onDoubleClickObject);
    }
    console.log([onClickObject, onDoubleClickObject]);
    return [onClickObject, onDoubleClickObject];
  }

  objectToPushInTableData(getOnClickProperties, getOnDoubleClickProperties);

  console.log(tabledata);
  const handleKeyDown = (event) => {
    if (event.ctrlKey && event.key === "Enter") {
      handleOk(); // Call your function here
    }
  }

  return (
    <>
      <main className="fixed inset-0 bg-opacity-50 flex flex-col items-center justify-center z-10"  onKeyDown={handleKeyDown}>
        <main className="w-[35rem] h-auto bg-white shadow-2xl rounded-lg">
          <header className="flex bg-gray-50 w-full p-2 items-center justify-between rounded-t-lg">
            <span className="text-lg font-medium">Action</span>
            <button
              onClick={closeModal}
              className="text-gray-500 hover:text-black"
            >
              <FaXmark />
            </button>
          </header>
          <div className="p-4 flex flex-col items-start justify-start gap-4">
            <p className="text-gray-600">
              Actions let you create interactive relationships between, and
              sheets and the web.
            </p>
            <h2 className="font-medium text-gray-700">
              Add action for this sheet
            </h2>

            <table className="min-w-full border border-gray-300">
              <thead>
                <tr className="bg-gray-50 font-medium text-gray-700">
                  <th className="border border-gray-300 p-[2px] text-left">
                    Name
                  </th>
                  <th className="border border-gray-300 p-[2px] text-left">
                    Trigger
                  </th>
                  <th className="border border-gray-300 p-[2px] text-left">
                    Action
                  </th>
                </tr>
              </thead>
              <tbody>
                {tabledata.map((item, index) => (
                  <tr
                    key={index}
                    onClick={() =>
                      handleRowSelection({
                        uuid: item.uuid,
                        parentKey: item.parentKey,
                        reduxKey: item.reduxKey,
                        Sheetid: item.Sheetid,
                        action: item.action,
                      })
                    }
                    className={`cursor-pointer ${
                      selectedRow !== null && selectedRow.uuid === item.uuid
                        ? "bg-gray-100 text-gray-700"
                        : ""
                    }`}
                  >
                    <td className="border p-[2px] font-light">{item.name}</td>
                    <td className="border p-[2px] font-light">
                      {item.reduxKey}
                    </td>
                    <td className="border p-[2px] font-light">{item.action}</td>
                  </tr>
                ))}
              </tbody>
            </table>

            <section className="w-full flex items-center justify-between">
              <Dropdown
                label={
                  <button className="text-black flex items-center justify-between w-28 border border-gray-300 rounded bg-white p-1">
                    {selectedAction !== null ? selectedAction : " Add action"}
                    <IoMdArrowDropdown className="text-xl text-black" />
                  </button>
                }
                arrowIcon={false}
                dismissOnClick={true}
                className="shadow-lg"
              >
                {actions.map((item, index) => (
                  <Dropdown.Item
                    key={index}
                    className="flex gap-2 items-center"
                    onClick={() => setSelectedAction(item.value)}
                  >
                    {item.value === "Filters" && <FiFilter />}
                    {item.value === "GoToSheet" && <VscGoToFile />}
                    {item.value === "GoToURL" && <TbWorld />}
                    {item.value === "hierarchy" && <VscTypeHierarchySub />}
                    {item.label}
                  </Dropdown.Item>
                ))}
              </Dropdown>
              <div className="flex gap-2">
                <button
                  disabled={selectedRow === null}
                  className={`text-black text-center w-20 border border-gray-300 rounded bg-white hover:bg-gray-100 ${
                    selectedRow === null ? "opacity-50" : ""
                  }`}
                  onClick={() => handleEdit(selectedRow.action)}
                >
                  Edit
                </button>
                <button
                  disabled={selectedRow === null}
                  className={`text-black text-center w-20 border border-gray-300 rounded bg-white hover:bg-gray-100 ${
                    selectedRow === null ? "opacity-50" : ""
                  }`}
                  onClick={() => handleRemove(selectedRow)}
                >
                  Remove
                </button>
              </div>
            </section>
          </div>
          <footer className="w-full flex items-center justify-end gap-4 p-3 bg-gray-50 rounded-b-lg">
            <button className="border w-20" onClick={closeModal}>
              Close
            </button>
            <button
              // disabled={selectedAction === null}
              className="border bg-blue-950 text-white w-20"
              onClick={handleOk}
            >
              Ok
            </button>
          </footer>
        </main>
      </main>

      {/* Second Modal */}
      {showSecondModal === "Filters" ? (
        <FilterActionModal
          CloseSecondModal={CloseSecondModal}
          handleSecondModalClose={handleSecondModalClose}
          sheetsArray={sheetsArray}
          sourceSheetObject={sourceSheetObject}
          targetSheetArray={targetSheetArray}
          properties={
            getOnClickProperties.length !== 1 &&
            getOnClickProperties.action === "Filters"
              ? getOnClickProperties
              : null ||
                (getOnDoubleClickProperties.length !== 1 &&
                  getOnDoubleClickProperties.action === "Filters")
              ? getOnDoubleClickProperties
              : null
          }
          tabledata={tabledata}
        />
      ) : null}
      {showSecondModal === "GoToSheet" ? (
        <GotoSheetActionModal
          CloseSecondModal={CloseSecondModal}
          handleSecondModalClose={handleSecondModalClose}
          sheetsArray={sheetsArray}
          sourceSheetObject={sourceSheetObject}
          targetSheetArray={targetSheetArray}
          properties={
            getOnClickProperties.length !== 1 &&
            getOnClickProperties.action === "GoToSheet"
              ? getOnClickProperties
              : null ||
                (getOnDoubleClickProperties.length !== 1 &&
                  getOnDoubleClickProperties.action === "GoToSheet")
              ? getOnDoubleClickProperties
              : null
          }
          tabledata={tabledata}
        />
      ) : null}
      {showSecondModal === "GoToURL" ? (
        <GoToUrlActionModal
          CloseSecondModal={CloseSecondModal}
          handleSecondModalClose={handleSecondModalClose}
          sheetsArray={sheetsArray}
          sourceSheetObject={sourceSheetObject}
          targetSheetArray={targetSheetArray}
          properties={
            getOnClickProperties.length !== 1 &&
            getOnClickProperties.action === "GoToURL"
              ? getOnClickProperties
              : null ||
                (getOnDoubleClickProperties.length !== 1 &&
                  getOnDoubleClickProperties.action === "GoToURL")
              ? getOnDoubleClickProperties
              : null
          }
          tabledata={tabledata}
        />
      ) : null}
    </>
  );
}
